import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerUserResponseSet } from '@backrs_ui/grow-ui/src/models/models';

import { Box, SxProps, Theme } from '@mui/material';

import { BlueprintAccountFields } from './BlueprintAccountFields';
import { SchoolLevelQuestionText } from '../atoms/SchoolLevelQuestionText';
import { SurveyCard } from '../atoms/SurveyCard';
import { isZipValid } from '../survey.util';

const STRINGS = appStrings.modules.survey.blueprintAccountFields;

type AccountFieldsQuestionProps = Readonly<{
  userResponseSet: CareerUserResponseSet;
  isStudent: boolean;
  isHighSchool: boolean;
  onZipChange: (value: string) => void;
  onSchoolChange: (value: string) => void;
  onGraduationYearChange: (value: string) => void;
  onStartTermChange: (value: string) => void;
  onStartYearChange: (value: string) => void;
  previousButton: React.ReactNode;
  nextButton: React.ReactNode;
}>;

export function AccountFieldsQuestion({
  userResponseSet,
  isStudent,
  isHighSchool,
  onZipChange,
  onSchoolChange,
  onGraduationYearChange,
  onStartTermChange,
  onStartYearChange,
  previousButton,
  nextButton,
}: AccountFieldsQuestionProps) {
  const zipCode = userResponseSet.zip_code ?? '';

  return (
    <SurveyCard width="600px">
      <SchoolLevelQuestionText title={STRINGS.title} question_body={STRINGS.subtitle} />
      <Box sx={bodySx}>
        <BlueprintAccountFields
          zipCode={zipCode}
          school={userResponseSet.school ?? ''}
          graduationYear={userResponseSet.graduation_year ?? ''}
          startTerm={userResponseSet.start_term ?? ''}
          startYear={userResponseSet.start_year ?? ''}
          onZipChange={onZipChange}
          onSchoolChange={onSchoolChange}
          onGraduationYearChange={onGraduationYearChange}
          onStartTermChange={onStartTermChange}
          onStartYearChange={onStartYearChange}
          showZipError={zipCode.length > 0 && !isZipValid(zipCode)}
          isStudent={isStudent}
          isHighSchool={isHighSchool}
        />
      </Box>
      <Box sx={buttonRowSx}>
        {previousButton}
        {nextButton}
      </Box>
    </SurveyCard>
  );
}

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  padding: backrs.spacing['spacing-3xl'],
});

const buttonRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: backrs.spacing['spacing-lg'],
  padding: backrs.spacing['spacing-3xl'],
  paddingTop: backrs.spacing['spacing-lg'],
});
